module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill red"
  }, [_c('polygon', {
    attrs: {
      "points": "10 16.6442673 21.6215729 5 34.993837 18.4271679 48.4139472 5.03389696 60 16.6278485 46.5938062 30.0462773 59.9749504 43.3725488 48.4551665 54.9484925 35.015043 41.631887 21.6264768 55 10.0299535 43.4147875 23.3871083 30.0302557"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12be71f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/incorrect.vue
// module id = 595
// module chunks = 1